/* RampReady - "Waar Nederland zich nu op voorbereidt" (live-laag).
 * Haalt /api/topical op en (her)ordent de server-side gerenderde topic-blocks: toont de top max_topics in
 * de gerangschikte volgorde, zet per topic de "In het nieuws: <aanleiding>"-kop, verbergt de rest.
 * Faalt de fetch -> de server-side baseline (eerste max_topics blocks) blijft staan. */
(function () {
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function fmtUpd(iso) { try { return 'bijgewerkt ' + new Date(iso).toLocaleString('nl-NL', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }); } catch (e) { return ''; } }

  document.querySelectorAll('[data-topical]').forEach(function (root) {
    var api = root.getAttribute('data-api-url');
    if (!api) return;
    var maxTopics = parseInt(root.getAttribute('data-max-topics'), 10) || 3;
    var container = root.querySelector('[data-topical-topics]');
    var liveEl = root.querySelector('[data-topical-live]');
    var updatedEl = root.querySelector('[data-topical-updated]');
    var blocks = Array.prototype.slice.call(root.querySelectorAll('[data-topic-handle]'));
    if (!container || !blocks.length) return;
    var byHandle = {};
    blocks.forEach(function (el) { byHandle[el.getAttribute('data-topic-handle')] = el; });

    fetch(api, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (data) {
        var list = (data && data.topics) ? data.topics : [];
        if (!list.length) return; // baseline blijft

        var headlineByHandle = {};
        var order = [];
        list.forEach(function (t) {
          if (byHandle[t.handle] && order.indexOf(t.handle) < 0) {
            order.push(t.handle);
            if (t.sampleHeadline) headlineByHandle[t.handle] = { headline: t.sampleHeadline, url: t.sampleUrl };
          }
        });
        // padding met overige aanwezige blocks (oorspronkelijke volgorde) tot max_topics
        blocks.forEach(function (el) { var h = el.getAttribute('data-topic-handle'); if (order.indexOf(h) < 0) order.push(h); });
        var finalH = order.slice(0, maxTopics);

        finalH.forEach(function (h) {
          var el = byHandle[h];
          if (!el) return;
          var eye = el.querySelector('[data-topic-eyebrow]');
          if (eye && headlineByHandle[h]) {
            eye.innerHTML = 'In het nieuws: <a href="' + esc(headlineByHandle[h].url) + '" target="_blank" rel="noopener nofollow">' + esc(headlineByHandle[h].headline) + '</a>';
          }
          el.hidden = false;
          container.appendChild(el); // herorden in ranking-volgorde
        });
        blocks.forEach(function (el) {
          if (finalH.indexOf(el.getAttribute('data-topic-handle')) < 0) el.hidden = true;
        });

        if (liveEl) { liveEl.hidden = false; liveEl.classList.add('is-live'); }
        if (updatedEl && data.updated) updatedEl.textContent = fmtUpd(data.updated);
      })
      .catch(function () { /* baseline blijft staan */ });
  });
})();
